import React, { FC } from 'react';
import { Button as AntButton } from 'antd';
import styled from 'styled-components';
import colors from '../../../utils/colors';

type Props = {
  children: any;
  onClick: any;
  size?: any;
  className?: any;
  outline?: boolean;
  loading?: boolean;
};

const Button: FC<Props> = ({ children, onClick, size = 'medium', className, outline = false, loading = false }) => {
  return (
    <CustomButton
      onClick={onClick}
      size={size}
      className={className}
      textcolor={outline ? colors.primaryPurple : colors.white}
      backgroundcolor={outline ? colors.white : colors.primaryPurple}
      loading={loading}
    >
      {children}
    </CustomButton>
  );
};

export default Button;

const CustomButton = styled(AntButton) <{ textcolor: string; backgroundcolor: string }>`
  color: ${props => props.textcolor};
  background-color: ${props => props.backgroundcolor};
  border-radius: 40px;
  min-width: 80px;
  box-sizing: border-box;
  font-family: 'Quicksand', sans-serif;
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
  text-transform: uppercase;

  &:hover {
    color: ${props => props.textcolor};
    background-color: ${props => props.backgroundcolor};
    outline: none !important;
    border-color: ${props => props.backgroundcolor} !important;
    opacity: 0.75;
  }

  &:focus,
  :active {
    color: ${props => props.textcolor};
    background-color: ${props => props.backgroundcolor};
    border-color: ${props => props.backgroundcolor} !important;
    outline: none !important;
  }
`;
